import { hideAllInMain, manageErrorBox, loadStart, showBackButton } from './uxManagement';
const xml2js = require('xml2js');

export function loginSystem() {
  localStorageValidation();
  const loginButton = document.querySelectorAll('#menu-login-button');
  const logoutButton = document.querySelectorAll('#menu-logout-button');

  loginButton.forEach(element => {
    element.addEventListener('click', () => {
      hideAllInMain();
      document.getElementById('login-container').classList.add('visible');
      showBackButton();
      localStorageValidation();
    });
  });

  logoutButton.forEach(element => {
    element.addEventListener('click', () => {
      localStorage.removeItem('wlUsername');
      localStorage.removeItem('wlPassword');
      localStorage.removeItem('wlUserInformation');
      localStorageValidation();
      window.location.reload();
    });
  });

  const loginForm = document.getElementById('login-form');
  loginForm.addEventListener('submit', function(event) {
    if (loginForm.checkValidity()) {
      event.preventDefault();
      sendLoginRequest();
    } else if (!loginForm.checkValidity()) {
      event.preventDefault();
    }
  });

  function buttonVisibility(loggedIn) {
    const loginButton = document.querySelectorAll('#menu-login-button');
    const logoutButton = document.querySelectorAll('#menu-logout-button');

    loginButton.forEach(element => {
      if (loggedIn == true) {
        element.classList.add('hidden');
      } else if (loggedIn == false) {
        element.classList.remove('hidden');
      }
    });

    logoutButton.forEach(element => {
      if (loggedIn == true) {
        element.classList.remove('hidden');
      } else if (loggedIn == false) {
        element.classList.add('hidden');
      }
    });
  }

  function localStorageValidation() {
    if (localStorage.getItem('wlUsername')) {
      buttonVisibility(true);
    } else {
      buttonVisibility(false);
    }
  }

  function sendLoginRequest() {
    const mailadress = document.getElementById('username').value;
    const password = document.getElementById('password').value;
    const bodyXML = `<?xml version="1.0" encoding="iso-8859-1"?><soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/"><soap:Body><CustomerLogin><SecretKey>MG65Y0XPmQqNWrLeTCp2Rm11obRDDL7Y</SecretKey><User>${mailadress}</User><Password>${password}</Password></CustomerLogin></soap:Body></soap:Envelope>`;

    const headers = new Headers();
    headers.append('Content-Type', 'application/xml');

    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', function() {
      if (this.readyState === 4) {
        const parser = new xml2js.Parser({ explicitArray: false });
        parser.parseString(this.responseText, function(err, result) {
          if (err || result == null) {
            manageErrorBox('Inloggningsfel', 'Något gick fel vid inloggningen testa igen om en liten stund.');
          } else {
            if (result['soap:Envelope']['soap:Body'].CustomerLogin) {
              // const customerRespons = result['soap:Envelope']['soap:Body'].CustomerLogin;
              localStorage.setItem('wlUserInformation', JSON.stringify(result['soap:Envelope']['soap:Body'].CustomerLogin));
              localStorage.setItem('wlUsername', mailadress);
              localStorage.setItem('wlPassword', password);
              localStorageValidation();

              hideAllInMain();
              loadStart();
            } else {
              manageErrorBox('Felaktigt användarnamn/lösenord', 'Din inloggningsinformation är felaktig. Kontrollera användarnamn och lösenord och försök igen.');
            }
          }
        });
      } else if (this.status >= 400) {
        manageErrorBox('Inloggningsfel', 'Något gick fel vid inloggningen testa igen om en liten stund.');
      }
    });

    xhr.open('POST', 'https://butik.honsboa.se/cors.php');
    xhr.setRequestHeader('Content-Type', 'application/xml');

    xhr.send(bodyXML);
  }
}
